// extracted by mini-css-extract-plugin
export default {"headerLanguage":"languageButtons_headerLanguage__E7Mhh","languageSelectors":"languageButtons_languageSelectors__udleN"};